// extracted by mini-css-extract-plugin
export var addButton = "_nf-0";
export var border = "_nf-8";
export var check = "_nf-h";
export var danger = "_nf-6";
export var dropdownContainer = "_nf-1";
export var editModalBody = "_nf-j";
export var footerContainer = "_nf-i";
export var fullWidth = "_nf-a";
export var hide = "_nf-9";
export var icon = "_nf-3";
export var input = "_nf-7";
export var inputFlex = "_nf-b";
export var inputWrapper = "_nf-c";
export var manualFocus = "_nf-5";
export var optionButton = "_nf-4";
export var pillWrapper = "_nf-e";
export var pointer = "_nf-2";
export var showOverflow = "_nf-f";
export var tagsFlex = "_nf-d";
export var xButton = "_nf-g";